module.exports = __webpack_public_path__ + "static/media/IDIS.a9bd7367.jpg";